import styled from "styled-components";
import Spring from "../../components/Spring";

export const StyledContact = styled(Spring)`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};
    min-height: calc(100vh - 50px);

    position: relative;
    h2 {
        text-align: center;
    }
    padding-bottom: 24px;
`;

export const SpringSm = styled.div`
    max-width: 550px;
    margin: auto;
    textarea {
        resize: vertical;
        min-height: 200px;
        max-height: 350px;
    }
`;

export const StyledRecaptcha = styled.div`
    width: 302px;
    margin: auto;
    margin-bottom: 16px;

    &.Disabled {
        pointer-events: none;
    }
`;
